import script from "./ProposalStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalStatus.vue?vue&type=script&setup=true&lang=js"

import "./ProposalStatus.vue?vue&type=style&index=0&id=b28655f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b28655f4"]])

export default __exports__